import React, { Component } from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import {
  Form, Card, Container, Grid, Page, Dimmer,
} from 'tabler-react';
import ItemTable from '../components/ItemTable';
import LocationOptions from '../components/LocationSelect';
import debounce from '../utils/debounce';

const allItems = gql`
query searchItems($offset: Int, $term: String!, $locations: [String]) {
  search(offset: $offset, term: $term, locations: $locations) {
    nextOffset
    totalCount
    items {
      imageUrl
      id
      endsAt
      descriptionData {
        condition
        description
        msrp
      }
      location
      highBidderId
      lastHighBid
      itemUrl
    }
    nextOffset
  }
}
`;


class Search extends Component {
  state = {
    term: 'Couch',
    searchTerm: 'Couch',
    locations: [],
    offset: 0,
    lastOffset: 0,
  }

  handleChangeSearchTerm = debounce(() => this.setState({ searchTerm: this.state.term }), 100);

  handleSelectLocation = ({ target: { value } }) => {
    const { locations } = this.state;
    let newLocations = locations.slice(0);
    if (locations.includes(value)) {
      newLocations = locations.filter(loc => loc !== value);
    } else {
      newLocations.push(value);
    }

    this.setState({ locations: newLocations });
  }

  handleSetTerm = (term) => {
    this.setState({ term });
    this.handleChangeSearchTerm();
  }

  nextPage = ({ nextOffset }) => {
    this.setState({ lastOffset: this.state.offset, offset: nextOffset });
  }

  prevPage = ({ nextOffset }) => {
    this.setState({
      lastOffset: Math.max(0, this.state.lastOffset - (nextOffset - this.state.offset)),
      offset: Math.max(0, this.state.lastOffset),
    });
  }

  render() {
    const {
      locations, searchTerm, offset,
    } = this.state;
    return (
      <Container>
        <Page.Header>
          <Page.Title>
          Search
          </Page.Title>
        </Page.Header>
        <Grid.Row>
          <Grid.Col lg={12}>
            <Form.Group className="">
              <Form.Input
                icon="search"
                placeholder="Search for..."
                position="append"
                onChange={({ target: { value } }) => this.handleSetTerm(value)}
                value={this.state.term}
              />
            </Form.Group>
          </Grid.Col>
        </Grid.Row>
        <Grid.Row>
          <Grid.Col lg={2}>
            <Card>
              <Card.Body>
                <LocationOptions handleSelectLocation={this.handleSelectLocation} locations={locations} />
              </Card.Body>
            </Card>
          </Grid.Col>
          <Grid.Col lg={10}>
            <Card>
              <Query
                query={allItems}
                variables={{
                  term: searchTerm,
                  locations,
                  offset,
                }}
              >
                {({
                  loading, error, data,
                }) => {
                  const items = data.search && data.search.items;
                  if (loading && !items) {
                    return (
                      <Card.Body>
                        <Dimmer active loader />
                      </Card.Body>
                    );
                  }
                  if (error) {
                    return error.toString();
                  }
                  const searchItems = (items) || [];
                  const { nextOffset } = data.search;
                  return (
                    <ItemTable
                      nextPage={() => this.nextPage({ nextOffset })}
                      prevPage={() => this.prevPage({ nextOffset })}
                      onClick={({ itemUrl }) => window.open(itemUrl, '_blank')}
                      firstPage={offset === 0}
                      lastPage={searchItems.length < 40}
                      items={searchItems}
                    />
                  );
                }}
              </Query>
            </Card>
          </Grid.Col>
        </Grid.Row>
      </Container>
    );
  }
}

export default Search;



// WEBPACK FOOTER //
// ./src/search/index.js